import { Controller, FieldValues, FieldPath, UseControllerProps } from 'react-hook-form';
import { DropdownOption } from 'uikit/inputs/dropdown/appDropdownInput';
import { AppDropdownField, AppDropdownFieldProps } from '../fields/dropdown/dropDownField';

export type HookFormDropDownFieldProps<
  T extends DropdownOption,
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<AppDropdownFieldProps<T>, 'onChange' | 'value' | 'isMultiple'> & {
  name: TName;
  control: UseControllerProps<TFieldValues>['control'];
  rules?: UseControllerProps<TFieldValues>['rules'];
};

export function HookFormDropDownField<T extends DropdownOption, TFieldValues extends FieldValues = FieldValues>(
  props: HookFormDropDownFieldProps<T, TFieldValues>,
) {
  const { control, name, rules, options, ...rest } = props;

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value, ref }, fieldState: { error }, formState: { isSubmitting } }) => (
        <div tabIndex={0} ref={ref}>
          <AppDropdownField<T>
            options={options}
            value={options.find((o) => o.key === value)}
            onChange={(e) => onChange(e?.key ?? null)}
            {...rest}
            errorProps={{
              ...props.errorProps,
              errors: error?.message ?? props.errorProps?.errors,
            }}
            disabled={props.disabled || isSubmitting}
          />
        </div>
      )}
    />
  );
}
